import React from 'react';

import { AppBar, Toolbar, Typography, Button, Container, Box, Paper } from '@mui/material';

import { useAuth } from '../../services/auth/AuthContext';
import NotificationService from '../../services/notification/NotificationService';

function LoginPage() {
  const { isAuthenticated, login, logout } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
      NotificationService.success('Successfully logged in!');
    } catch (error) {
      NotificationService.error('Login failed!');
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      NotificationService.success('Successfully logged out!');
    } catch (error) {
      NotificationService.error('Logout failed!');
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            CJ Brothers Data Portal
          </Typography>
          {isAuthenticated ? (
            <Button color="inherit" onClick={handleLogout} sx={{ cursor: 'pointer' }}>
              Log Out
            </Button>
          ) : (
            <Button color="inherit" onClick={handleLogin}>
              Log In
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Welcome
          </Typography>
          <Typography variant="body1" component="p">
            {isAuthenticated ? (
              'You\'re logged in! Try calling the private API.'
            ) : (
              <Typography onClick={handleLogin}>Please log in.</Typography>
            )}
          </Typography>
          {isAuthenticated && (
            <Typography> You are logged in! Try calling the private API.</Typography>
          )}
        </Paper>
      </Container>
    </Box>
  );
}

export default LoginPage;
